import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Container, Image, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import Get from "../api/Get";
import { BASE_URL_WS, GET_APPOINTMENT_BY_ID, GET_EPS, SURVEY_ANSWER_SAVE, SURVEY_GET } from "../api/Routes";
import ErrorComunication from "../components/autoagendamiento/ErrorComunication";
import DoctorCitaConcluido from "../components/conferencedoctor/DoctorCitaConcluido";
import StatusCita from "../components/conferencepublic/StatusCita";
import NoDataToShow from "../components/NoDataToShow";
import { authContext } from "../context/AuthContext";
import useCompanyType from "../hook/useCompanyType";
import LoadingList from "../loader/LoadingList";
import { compareDate } from "../utils/compareDate";
import { isBase64 } from "../utils/isBase64";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import iconRecheck from '../img/icons/recheck.svg'
import DoctorCitaNoComienza from "../components/conferencedoctor/DoctorCitaNoComienza";
import DoctorCitaNoComienzaDiferentDay from "../components/conferencedoctor/DoctorCitaNoComienzaDiferentDay";
import DoctorEnCita from "../components/conferencedoctor/DoctorEnCita";
import ComponentModalEncuentaDoctor from "../components/conferencedoctor/ComponentModalEncuentaDoctor";
import Post from "../api/Post";
import { setTimeAppointment } from "../utils/setTimeAppointment";
import ComponentModalPacienteMexico from "../components/conferencedoctor/ComponentModalPacienteMexico";
import { isConsultorio } from "../utils/isConsultorio";
import ComponentModalPacienteColombia from "../components/conferencedoctor/ComponentModalPacienteColombia";
import SockJsClient from 'react-stomp';
import ComponentModalConsentimiento from "../components/cita/ComponentModalConsentimiento";
import Transcripcion from "../components/hismart/Transcripcion";

function DoctorConference({ t }) {
    const { idParam } = useParams()
    const id = isBase64(idParam) ? atob(idParam) : null;
    const { auth } = useContext(authContext)
    const history = useHistory()
    const [estado, setEstado] = useState("loading")
    const [textLoading, setTextLoading] = useState('Validando datos de la cita')
    const [codeServer, setCodeServer] = useState(null)
    const [textoStatusCita, setTextoStatusCita] = useState('')
    const [cita, setCita] = useState(null)
    const [messageCita, setMessageCita] = useState('')
    const companyType = useCompanyType()
    const [timeToStart, setTimeToStar] = useState(-1)
    const [jitsi, setJitsi] = useState(null)
    const [showEncuesta, setShowEncuesta] = useState(false)
    const [question, setQuestion] = useState([])
    const [hangUp, setHangUp] = useState(false)
    const [startMet, setStartMet] = useState(false)
    //edit data patient only colombia
    const [dataEdit, setDataEdit] = useState(null)
    const [showDataEdit, setShowDataEdit] = useState(false)
    const handleCloseEditData = () => setShowDataEdit(false)
    //end edit data patient only colombia
    //handle error modal
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => setShowModalServer(false)
    const [errorServer, setErrorServer] = useState(null)
    //end handle error modal
    //handle success modal
    const [showSuccess, setShowSuccess] = useState(false)
    const handleCloseSuccess = () => setShowSuccess(false);
    //end handle success modal

    //modal paciente mexico
    const [showModalPaciente, setShowModalPaciente] = useState(false)
    const [dataPatient, setDataPatient] = useState(null)
    //end modal paciente mexico

    //btn consulta fallida
    const [showBtnConsultaFallida, setShowBtnConsultaFallida] = useState(false)
    const [isJoinedPatient, setIsJoinedPatient] = useState(false)

    //eps
    const [epsOpt, setEpsOpt] = useState([])

    //volver hacer peticion en historiaclinicia
    const [reload, setReload] = useState(true)

    // Colombia: shared with historia clínica + HiSmart (al menos un diagnóstico)
    const [validDiagnostico, setValidDiagnostico] = useState(false)

    //prop handle consentimiento informado
    const [openConsentimiento, setOpenConsentimiento] = useState(false)
    const [approveConsentimiento, setApproveConsentimiento] = useState(false)

    useEffect(() => {
        if (id) {
            Get({ url: `${GET_APPOINTMENT_BY_ID}/${id}`, access_token: auth.data.access_token })
                .then(respCita => {
                    //console.log(respCita)
                    let current_cita = respCita.data.data
                    console.log(current_cita)
                    setCita(current_cita)
                    let afterBefore = compareDate(current_cita.currentTime, current_cita.scheduleDTO.dateTimeEnd)
                    let fechaInit = compareDate(current_cita.currentTime, current_cita.scheduleDTO.dateTimeInit)
                    let sameDay = moment(current_cita.currentTime, "DD/MM/YYYY HH:mm:ss").format("DD-MM-YYYY") === moment(current_cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY")

                    let startM = moment(current_cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                    let ServerTime = moment(current_cita.currentTime, "DD/MM/YYYY HH:mm:ss")
                    //console.log(current_cita)
                    if (current_cita.appointmentStatus === 'Pendiente') {
                        setTextoStatusCita('Su cita se encuentra pendiente de aprobación')
                        setEstado("statusCita")
                    } else if (current_cita.appointmentStatus === "CanceladaSinPago") {
                        setTextoStatusCita("Cita cancelada sin pago")
                        setEstado("statusCita")
                    }
                    else if (current_cita.appointmentStatus === 'Cancelada') {
                        setTextoStatusCita('Su cita ha sido cancelada.')
                        setEstado("statusCita")
                    }
                    else if (current_cita.appointmentStatus === "NoAtendida" ||
                        (afterBefore === "terminado" && current_cita.dataVideoCallList.length === 0 && current_cita?.scheduleDTO?.scheduleType?.id !== 'Consultorio'
                        )) {
                        setTextoStatusCita("Esta cita no ha sido atendida")
                        setEstado("statusCita")
                    } else if (current_cita.appointmentStatus === "Fallida") {
                        setTextoStatusCita("Cita fallida")
                        setEstado("statusCita")
                    }
                    else if (current_cita.finished || afterBefore === "terminado") {
                        setMessageCita(t('cita_concluido'))
                        setEstado("citaConcluido")
                    }
                    else if (fechaInit === "noTerminado" && sameDay) {
                        //la cita aun no comienza
                        setMessageCita(t('cita_comenzara'))
                        let time = startM.diff(ServerTime, "seconds")
                        setTimeToStar(time)
                        setEstado("citaNoComienza")
                    }
                    else if (fechaInit === "noTerminado" && !sameDay) {
                        //la cita aun no comienza
                        setMessageCita(t('cita_no_comenzado'))
                        setEstado("citaNoComienzaDiferentDay")
                    } else {
                        const legalW = current_cita?.legalWarnings.length > 0 ? current_cita.legalWarnings[0] : null
                        if (legalW?.acceptPatient === 'pending' && isConsultorio(auth.data.role)) {
                            setOpenConsentimiento(true)
                        }
                        setEstado("enCita")
                        setTimeToStar(-1)
                    }
                })
                .catch(error => {
                    setShowModalServer(true)
                    if (error.response) {
                        setErrorServer(error.response)
                        setCodeServer(error.response.data.status)
                    }
                    setEstado("errorComunication")
                })


            //Get encuesta de satisfacción
            Get({ url: `${SURVEY_GET}/doctor`, access_token: auth.data.access_token })
                .then(resp => {
                    const data = resp.data.data.response
                    setQuestion(data)
                })
                .catch(error => {
                    setShowModalServer(true)
                    if (error.response) {
                        setErrorServer(error.response)
                    }
                })
        } else {
            setEstado("notFoundAppointment")
        }
    }, [])

    //effecto para cuando cualga la llamada
    useEffect(() => {
        if (hangUp) {
            setTimeAppointment(id, 'Doctor', false, cita.dataVideoCallList, auth)
            setHangUp(false)
        }
    }, [hangUp])

    //effecto para cuando empieza la llamada
    useEffect(() => {
        if (startMet) {
            setTimeAppointment(id, 'Doctor', true, cita.dataVideoCallList, auth)
            setStartMet(false)
        }
    }, [startMet])

    const handleShowEditData = () => {
        const { patientDTO } = cita
        let dEdit = {
            ...patientDTO,
            peso: cita.peso,
            talla: cita.talla,
            idCita: cita.id,
            motivoConsulta: cita.motivoConsulta

        }
        setDataEdit(dEdit)
        setShowDataEdit(true)
    }

    const handleShowEditDataMexico = () => {
        const { patientDTO } = cita
        // console.log(cita.peso)
        // console.log(cita.talla)
        // console.log(cita.motivoConsulta)
        //console.log(patientDTO)

        //window.open(`/admin/patients/create?id=232`, "", "width=1000, height=700")
        let dEdit = {
            id: patientDTO.id,
            name: patientDTO.name ?? '',
            middleName: patientDTO.middleName ?? '',
            seccondSurname: patientDTO.seccondSurname ?? '',
            lastName: patientDTO.lastName ?? '',
            gender: patientDTO.gender ?? '',
            dateOfBirthday: patientDTO.dateOfBirthday ?? '',
            maritalStatus: patientDTO.maritalStatus ?? '',
            nationality: patientDTO.nationality ?? '',
            phoneNumber: patientDTO.phone ?? '',
            phoneNumber2: patientDTO.phone2 ?? '',
            email: patientDTO.email ?? '',
            country: patientDTO.country ?? '',
            religion: patientDTO.religionDTO ?? '',
            bloodType: patientDTO.bloodType ?? '',
            occupation: patientDTO.occupation ?? '',
            language: patientDTO.languageDTO ?? '',
            address: patientDTO.address ?? '',
            allergies: patientDTO.allergies ?? '',
            account: patientDTO.account ?? '',
            company: patientDTO.company ?? '',
            medicalHistory: patientDTO.medicalHistory ?? '',
            externalId: patientDTO.externalId ?? '',
            cp: patientDTO.cp ?? '',
            municipio: patientDTO.municipio ?? '',
            state: patientDTO.state ?? '',
            patientRelationship: patientDTO.patientRelationshipDTO ?? '',
            peso: cita.peso ?? '',
            talla: cita.talla ?? '',
            motivoConsulta: cita.motivoConsulta ?? '',
            curp: patientDTO.curp ?? '',
            derechohabiencia: patientDTO.derechohabiencia ?? '',
            programaSMyMG: patientDTO.programaSMyMG ?? '',
            primeraVezAnio: patientDTO.primeraVezAnio ?? '',
            primeraVezUnemeSaih: patientDTO.primeraVezUnemeSaih ?? '',
            tipoDificultad: patientDTO.tipoDificultad ?? '',
            gradoDificultad: patientDTO.gradoDificultad ?? '',
            origenDificultad: patientDTO.origenDificultad ?? '',
            seConsideraIndigena: patientDTO.seConsideraIndigena ?? '',
            seAutodenominaAfromexicano: patientDTO.seAutodenominaAfromexicano ?? '',
            migrante: patientDTO.migrante ?? '',
            idCita: cita.id
        }
        setDataPatient(dEdit)
        setShowModalPaciente(true)
        //setShowDataEdit(true)
    }

    const handleAPI = (JitsiMeetAPI) => {
        setJitsi(JitsiMeetAPI)

        if (!isConsultorio(auth.data.role)) {
            if (cita.patientDTO.account?.allowRecord) {
                JitsiMeetAPI.addEventListener("videoConferenceJoined", () => {
                    JitsiMeetAPI.executeCommand("startRecording", { mode: `file` })
                    setStartMet(true)
                })
            } else {
                JitsiMeetAPI.addEventListener("videoConferenceJoined", () => {
                    JitsiMeetAPI.executeCommand("stopRecording", 'file')
                    setStartMet(true)
                })
            }
        }



        JitsiMeetAPI.addEventListener("videoConferenceLeft", () => {
            //JitsiMeetAPI.executeCommand("hangup")
            setMessageCita(t('cita_concluido'))
            setEstado("citaConcluido")
            setShowEncuesta(true)
        })

        //colgar llamada
        JitsiMeetAPI.addEventListener("readyToClose", () => {
            console.log('colgar llamada')
            setHangUp(true)
        })

        JitsiMeetAPI.addEventListener("participantJoined", (e) => {
            console.log('------------------------participantJoined------------------------')
            //setIsJoinedPatient(true)
            const participants = JitsiMeetAPI.getNumberOfParticipants();
            if (participants >= 2) {
                handleAPI.executeCommand('startRecording', { mode: "file" });
            }
        })

        if (companyType === 'colombia') {
            console.log('overwrite')
            JitsiMeetAPI.executeCommand("overwriteConfig", {
                toolbarButtons: ['chat', 'camera', 'microphone', 'recording', 'select-background', 'settings', 'toggle-camera', 'tileview', 'recording', 'hangup'],
            })
        }

    }

    useEffect(() => {
        if (companyType === 'colombia') {
            if ((jitsi && showBtnConsultaFallida) || (jitsi && isJoinedPatient)) {
                jitsi.executeCommand("overwriteConfig", {
                    toolbarButtons: ['chat', 'camera', 'hangup', 'microphone', 'recording', 'select-background', 'settings', 'toggle-camera', 'tileview', 'recording', 'hangup'],
                })
            }
        }
    }, [showBtnConsultaFallida, companyType, isJoinedPatient])

    const onComplete = () => {
        setTimeout(() => {
            setHangUp(true)
            setMessageCita(t('cita_concluido'))
            setEstado("citaConcluido")
            setShowEncuesta(!isConsultorio(auth.data.role))
        }, 1000)
    }

    const handleCloseEncuesta = () => {
        let d = {
            id: parseInt(id),
            surveys: []
        }
        //enviamos la encuesta vacia
        Post({ url: SURVEY_ANSWER_SAVE, data: d, access_token: auth.data.access_token, header: true })
            .then(response => {
                setShowEncuesta(false)
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                    history.replace("/admin")
                }, 2000);
            })
            .catch(error => {
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })

    };

    const handleCloseModalPacienteMexico = () => {
        setShowModalPaciente(false)
    }

    const onCompleteTimeStart = () => {
        const legalW = cita?.legalWarnings?.length > 0 ? cita?.legalWarnings[0] : null
        if (legalW?.acceptPatient === 'pending' && isConsultorio(auth.data.role)) {
            setOpenConsentimiento(true)
        }
        setEstado("enCita")
        setTimeToStar(-1)
    }

    //eps
    useEffect(() => {
        //eps
        Get({ url: GET_EPS, access_token: auth.data.access_token })
            .then(response => {
                if (response.data.state) {
                    setEpsOpt(response.data.data.response.map(el => ({ label: el.nombreEps, value: el.id })))
                }
            }).catch(error => {

            })
    }, [])

    const [isLissentSocket, setIsLissentSocket] = useState(true)
    const handleMessage = (message) => {
        console.log(message)
        if (message && isLissentSocket) {
            if (companyType === 'colombia') {
                handleShowEditData()
            } else {
                handleShowEditDataMexico()
            }
            setIsLissentSocket(false)
        }
    }


    const estadosMap = {
        loading: <LoadingList texto={textLoading} />,
        foundedApppointment: true,
        notFoundAppointment: <NoDataToShow text={t('url_no_valida')} />,
        errorComunication: <ErrorComunication text="En estos momentos no podemos procesar su cita" codeServer={codeServer} />,
        statusCita: <StatusCita text={textoStatusCita} helpCenter={cita?.patientDTO?.account?.helpCenter} cita={cita} doctor={true} />,
        citaConcluido: <DoctorCitaConcluido messageCita={messageCita} cita={cita} companyType={companyType} setCita={setCita}
            handleShowEditData={handleShowEditData} handleShowEditDataMexico={handleShowEditDataMexico}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
            reload={reload} setReload={setReload}
        />,
        citaNoComienza: <DoctorCitaNoComienza messageCita={messageCita} cita={cita} noComienza={true}
            companyType={companyType} onCompleteTimeStart={onCompleteTimeStart}
            handleShowEditData={handleShowEditData} handleShowEditDataMexico={handleShowEditDataMexico}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
        />,
        citaNoComienzaDiferentDay: <DoctorCitaNoComienzaDiferentDay messageCita={messageCita} cita={cita}
            companyType={companyType} noComienza={true}
            handleShowEditData={handleShowEditData} handleShowEditDataMexico={handleShowEditDataMexico}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
        />,
        enCita: <DoctorEnCita cita={cita} setCita={setCita} onComplete={onComplete} handleAPI={handleAPI} noComienza={false}
            companyType={companyType} setShowEncuesta={setShowEncuesta}
            handleShowEditData={handleShowEditData} handleShowEditDataMexico={handleShowEditDataMexico}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
            showEncuesta={showEncuesta} showBtnConsultaFallida={showBtnConsultaFallida} setShowBtnConsultaFallida={setShowBtnConsultaFallida}
            isJoinedPatient={isJoinedPatient} reload={reload} setReload={setReload} setOpenConsentimiento={setOpenConsentimiento}
            validDiagnostico={validDiagnostico} setValidDiagnostico={setValidDiagnostico}
        />,
    }


    return (
        <div className="content mh-100vh">
            <Container fluid className="py-3">
                {
                    estadosMap[estado]
                }

                <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                    <Modal.Body className="p-0">
                        <div className="text-center position-relative overflow-hidden h-100p">
                            <Image src={iconRecheck} fluid className="img-recheck" />
                            <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                        </div>
                    </Modal.Body>
                </Modal>

            </Container>

            <ComponentModalPacienteColombia
                showModal={showDataEdit}
                handleClose={handleCloseEditData}
                data={dataEdit}
                setCita={setCita}
            />

            <ComponentModalPacienteMexico
                showModal={showModalPaciente}
                handleClose={handleCloseModalPacienteMexico}
                data={dataPatient}
                setCita={setCita}
            />

            <ComponentModalEncuentaDoctor
                cita={cita}
                show={showEncuesta}
                setShowEncuesta={setShowEncuesta}
                setShowSuccess={setShowSuccess}
                handleClose={handleCloseEncuesta}
                question={question}
                setShowModalServer={setShowModalServer}
                setErrorServer={setErrorServer}
            />

            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />

            {(cita && companyType === 'colombia') &&
                <ComponentModalConsentimiento
                    open={openConsentimiento}
                    setOpen={setOpenConsentimiento}
                    setApproveConsentimiento={setApproveConsentimiento}
                    cita={cita}
                />}

            <SockJsClient
                url={`${BASE_URL_WS}/ws`}
                topics={[`/user/${id}/queue/patientConnected`]}
                onMessage={(message) => handleMessage(message)}
            />
            {(cita && companyType === 'colombia') &&
                <Transcripcion cita={cita} data={auth.data} setShowEncuesta={setShowEncuesta} setReload={setReload} setCita={setCita} appointmentId={id}
                    validDiagnostico={validDiagnostico}
                />
            }
        </div>
    )
}

export default withTranslation()(DoctorConference)